<template>
  <div id="app">
    <navbar class="mb-5"/>
    <progress
        v-if="AppStoreStore.loading"
        class="progress is-primary is-small mt-6"
        max="100"
    ></progress>
    <div class="columns">
      <div
          class="column"
          :class="{
            'is-8': AppStoreStore.openReviewSideBar,
            'is-12': !AppStoreStore.openReviewSideBar
          }"
      >
        <div class="container">
          <wizard ref="wizard" :formData="formData" />
        </div>
      </div>
      <div class="column is-4" v-if="AppStoreStore.openReviewSideBar">
        <review-sidebar @nextTab="nextTab" :formData="formData"></review-sidebar>
      </div>
    </div>
  </div>
</template>

<script>
import Wizard from "@/components/Wizard/Index";
import Navbar from "@/components/Wizard/Navbar";
import { mapStores } from 'pinia'

import { useAppStore } from "@/stores/AppStore";
import ReviewSidebar from "@/components/Wizard/ReviewSidebar/Index";
import notificationsApi from "@/apis/notifications";

export default {
  name: 'app',

  components: {
    Wizard,
    Navbar,
    ReviewSidebar
  },

  data() {
    return {
      formData: {
        integration: {
          showStep: true,
          data: {
            type: null
          },
          hasSum: false,
        },
        partner: {
          showStep: true,
          data: {},
          hasSum: true
        },
        technicalManager: {
          showStep: false,
          data: {},
          hasSum: false
        },
        recommender: {
          showStep: false,
          data: {},
          hasSum: false
        },
        legalGuardian: {
          showStep: false,
          data: {},
          hasSum: false
        },
        company: {
          showStep: false,
          data: {},
          hasSum: false
        },
        customer: {
          showStep: false,
          data: {},
          hasSum: false
        }
      }
    }
  },

  mounted() {
    const queryData = this.$route.query
    console.log(queryData);
    if (queryData.idExterno !== undefined) {
      // Company Data
      this.formData.company.data.network_id = queryData.id_rede;
      this.formData.company.data.external_id = queryData.idExterno;
      this.formData.company.data.flag_name = queryData.bandeira_nome;
      this.formData.company.data.neighbourhood = queryData.loja_bairro;
      this.formData.company.data.zipcode = queryData.loja_cep;
      this.formData.company.data.city = queryData.loja_cidade;
      this.formData.company.data.state = queryData.loja_uf;
      this.formData.company.data.cnpj_document = queryData.loja_cnpj;
      this.formData.company.data.additional_details = queryData.loja_complemento;
      this.formData.company.data.street = queryData.loja_endereco;
      this.formData.company.data.fantasy_name = queryData.loja_nome_fantasia;
      this.formData.company.data.number = queryData.loja_numero;
      this.formData.company.data.social_reason = queryData.loja_razao_social;

      // Legal Guardian Data
      this.formData.legalGuardian.data.cpf_document = queryData.usuario_cpf;
      this.formData.legalGuardian.data.email = queryData.usuario_email;
      this.formData.legalGuardian.data.name = queryData.usuario_nome;
      this.formData.legalGuardian.data.phone_number = queryData.usuario_telefone;

      notificationsApi.send({
        external_id: queryData.idExterno,
        status: 'INICIADA'
      })
    }
  },

  methods: {
    nextTab() {
      this.$refs.wizard.nextTab()
    }
  },

  computed: {
    ...mapStores(useAppStore)
  }
}
</script>

<style lang="scss">

.container {
  padding: 40px;
}

[v-cloak] { display: none; }
</style>
